<template>
  <v-card max-width="100%">
    <v-carousel v-model="slide" height="300px" hide-delimiters>
      <v-carousel-item v-for="(image, index) in previews" :key="index">
        <v-img :src="image" height="100%" contain />
        <v-btn v-if="!max || previews.length < max" icon color="primary" absolute top left @click="add()">
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <v-btn icon color="primary" absolute top right @click="remove(index)">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-carousel-item>

      <v-carousel-item v-if="previews.length < 1">
        <v-card height="100%" @click="$refs.imgUpload.click()">
          <v-row class="fill-height" align="center" justify="center">
            <v-icon>fa-plus</v-icon>
          </v-row>
        </v-card>
      </v-carousel-item>
    </v-carousel>

    <input v-show="false" ref="imgUpload" multiple type="file" @change="onImageSelect()" >
  </v-card>
</template>

<script>

export default {
  name: 'GalleryInput',
  props: {
    max: {
      type: Number,
      default: 0
    },
    gallery: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      slide: 1
    }
  },
  computed: {
    previews () {
      return this.gallery.map(image => {
        if (image instanceof File) {
          return URL.createObjectURL(image)
        } else {
          return image
        }
      })
    }
  },
  methods: {
    onImageSelect () {
      const files = this.$refs.imgUpload.files
      const newGallery = this.gallery

      Array.from(files).forEach(file => {
        newGallery.push(file)
      })

      this.$emit('update:gallery', newGallery)

      this.slide = this.gallery.length + files.length - 1
      this.$refs.imgUpload.value = ''
    },
    add () {
      this.$refs.imgUpload.click()
    },
    remove (index) {
      this.gallery.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
